import type { CSSProperties } from "react";

export type ProfileBannerMode = "solid" | "gradient";

export function profileBannerStyle(
  color: string,
  mode: ProfileBannerMode,
  secondaryColor: string,
): CSSProperties {
  return mode === "gradient"
    ? { backgroundImage: `linear-gradient(135deg, ${color}, ${secondaryColor})` }
    : { backgroundColor: color, backgroundImage: "none" };
}
